/** Traduce un status HTTP a un mensaje humano y seguro -- nunca expone la traza, la URL
 * interna ni el nombre de la excepción. Cubre los códigos que la Mini App debe manejar sin
 * lanzar una excepción de React (401/403/404/409/429/500/502/503/504). */
const HTTP_ERROR_MESSAGES: Record<number, string> = {
  401: 'La sesión expiró.',
  403: 'No tienes acceso.',
  404: 'No encontramos la información.',
  409: 'Esta información ya cambió. Actualiza e inténtalo de nuevo.',
  429: 'Demasiadas solicitudes. Espera un momento.',
  500: 'Error interno.',
  502: 'El servicio no está disponible en este momento.',
  503: 'Servicio temporalmente no disponible.',
  504: 'Tiempo de espera agotado.',
}

export function getHttpStatus(error: unknown): number | undefined {
  if (error && typeof error === 'object' && 'response' in error) {
    const response = (error as { response?: { status?: number } }).response
    return response?.status
  }
  return undefined
}

export function getHttpErrorMessage(status: number | undefined): string {
  if (status !== undefined && HTTP_ERROR_MESSAGES[status]) {
    return HTTP_ERROR_MESSAGES[status]
  }
  return 'No pudimos cargar esta información.'
}
